import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PriceAlertV2 } from '../components/PriceAlertV2';
import { HeroV2 } from '../components/HeroV2';
import { TestimonialV2 } from '../components/TestimonialV2';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStackV2 } from '../components/ValueStackV2';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSectionV2 } from '../components/PricingSectionV2';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageV2() {
  const [showContent, setShowContent] = useState(false);
  const handleVideoMilestone = () => {
    setShowContent(true);
  };
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-894">
      <PriceAlertV2 data-id="element-895" />
      <HeroV2 onVideoMilestone={handleVideoMilestone} showCTA={showContent} data-id="element-896" />
      <AnimatePresence data-id="element-897">
        {showContent && <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-898">
            <TestimonialV2 data-id="element-899" />
            <ProblemSolution data-id="element-900" />
            <ValueStackV2 data-id="element-901" />
            <ModuleBreakdown data-id="element-902" />
            <Guarantee data-id="element-903" />
            <PricingSectionV2 data-id="element-904" />
            <Footer data-id="element-905" />
          </motion.div>}
      </AnimatePresence>
      {showContent && <RecentPurchaseToast data-id="element-906" />}
    </div>;
}